import React, { Component, useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { DatePicker } from "@material-ui/pickers";
import { setactiveTabObj } from "../../redux/actions/appActions";
import { connect } from "react-redux";
import { useHistory, withRouter, Route, Redirect, Switch } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import OffileDb from '../../config/pouchDB';
import '../../assets/css/Calendar.css';
import Button from "@material-ui/core/Button";
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@material-ui/icons/ThumbDownAltOutlined';
import Loader from "../loaders/loader";
import Questionnaire from "./Questionnaire";
import BlockIcon from '@material-ui/icons/Block';
import swal from "sweetalert";
import imgUrl from "../../assets/images/imageUrl.js";
import Calendarsettings from "./calendarsettings.js";
import Services from "../../api/api";

var tempDates = [];
class MaterialUIPickers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      selectedDate: new Date(),
      userCalenderRemainderInfo: props.userCalenderRemainderInfo,
      reminderTime: props.reminderTime,
      Today: (new Date()).toDateString(),
      showmodal: false,
      colorDatesObj: {},
      pillDates: [],
      missedPillDates: [],
      eatenPillDates: [],
      View: "calendar",
      firstBleeding: new Date(),
      reminderTime: new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
      reminderType: 1,
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.renderDayInPicker = this.renderDayInPicker.bind(this);
    this.onQuestionClick = this.onQuestionClick.bind(this);

  }


  componentDidMount() {
    OffileDb.setDatabase()
    console.log(this.props.reset)
    if (this.props.reset) {
      this.calculateDays(this.props.firstBleeding)
    } else {
      this.loadDatesData()
      // this.setState({
      //   isLoading: false
      // })
    }
  }


  loadDatesData() {
    var that = this
    OffileDb.getData('calenderDates').then(function (result) {
      console.log(result)
      if (!result.status && result.status != 400) {
        that.setState({
          pillDates: result.data.pillDates,
          missedPillDates: result.data.missedPillDates,
          colorDatesObj: result.data.colorDatesObj,
          showmodal: true,
        })
      }
      that.setState({
        isLoading: false
      })
    })
  }

  handleDateChange(date) {
    this.setState({
      selectedDate: date,
      showmodal: true
    })
  };

  getEndDate(val, element) {
    var date = new Date(val)
    var frequencyRemainderSet = element
    var remainderSetForTimeConfiguration = element.remainderSetForTimeConfiguration.toLowerCase();
    if (remainderSetForTimeConfiguration == "day" || remainderSetForTimeConfiguration == "days") {
      date.setDate(date.getDate() + element.remainderSetNumber);
    }
    if (remainderSetForTimeConfiguration == "week" || remainderSetForTimeConfiguration == "weeks") {
      let addday = 7 * element.remainderSetNumber
      date.setDate(date.getDate() + addday);
    } if (remainderSetForTimeConfiguration == "month" || remainderSetForTimeConfiguration == "months") {
      var firstMonth = val.getMonth();
      date = new Date(date.setMonth(firstMonth + element.remainderSetNumber));
    }
    return date
  }

  getIntervalSelection(val, t, element) {
    var date = new Date(val)
    var checkflg = false
    var remainderSetForIntervalSelection = element.remainderSetForIntervalSelection.toLowerCase();
    var remainderSetForRemainderType = element.remainderSetForRemainderType.toLowerCase();

    if (remainderSetForIntervalSelection == "day") {
      checkflg = true
    }

    if (remainderSetForIntervalSelection == "week" && remainderSetForRemainderType == "once") {
      if (t.getDay() == val.getDay()) {
        checkflg = true
      }
    } if (remainderSetForIntervalSelection == "week" && remainderSetForRemainderType == "twice") {
      var intervalDays = element.intervalSectionList[0]['intervalDays']
      var interdaay = (val.getDay() + intervalDays) % 7
      if (t.getDay() == val.getDay() || t.getDay() == interdaay) {
        checkflg = true
      }
    } if (remainderSetForIntervalSelection == "week" && remainderSetForRemainderType == "thrice") {
      var intervalDays1 = element.intervalSectionList[0]['intervalDays']
      var intervalDays2 = element.intervalSectionList[1]['intervalDays']
      var interdaay1 = (val.getDay() + intervalDays1) % 7
      var interdaay2 = (val.getDay() + intervalDays2) % 7
      if (t.getDay() == val.getDay() || t.getDay() == interdaay1 || t.getDay() == interdaay2) {
        checkflg = true
      }
    }

    return checkflg;
  }

  calculateDays(val) {
    console.log(val)
    var localTempMiss = [];
    tempDates = [];
    var frequencyRemainderSet = this.state.userCalenderRemainderInfo["userCalenderRemainderInfoList"]["userCalenderRemainderInfo"][0]["frequencyRemainderSet"];
    frequencyRemainderSet.forEach(element => {
      let enddate = this.getEndDate(val, element);
      for (var t = new Date(val); t <= enddate; t.setDate(t.getDate() + 1)) {
        var flag = this.getIntervalSelection(val, t, element)
        if (flag) {
          tempDates.push(t.toDateString())
        }
      }
    })

    console.log(tempDates)

    for (var dateStr of tempDates) {
      if (new Date(dateStr) <= new Date(this.state.Today)) {
        localTempMiss.push(dateStr);
      }
    }

    this.setState({
      pillDates: tempDates,
      missedPillDates: localTempMiss,
      isLoading: false
    })

    OffileDb.setData('calenderDates', {
      pillDates: tempDates,
      missedPillDates: localTempMiss,
      colorDatesObj: this.state.colorDatesObj
    })
    this.triggerReminder(tempDates)

  }



  setFirstBleeding(selectedDate) {
    console.log(selectedDate)
    this.calculateDays(selectedDate)
  }

  onQuestionClick(color, selectedDate) {
    var arr = this.state.missedPillDates
    if (!arr.includes(selectedDate.toDateString())) {
      arr.push(selectedDate.toDateString());
    }
    var colorObj = this.state.colorDatesObj;
    colorObj[selectedDate.toDateString()] = color
    this.setState({
      colorDatesObj: colorObj,
      showmodal: false,
      missedPillDates: arr
    })

    OffileDb.setData('calenderDates', {
      pillDates: this.state.pillDates,
      missedPillDates: arr,
      colorDatesObj: colorObj
    })
  }

  renderDayInPicker(date, selectedDate, dayInCurrentMonth, dayComponent) {
    if (this.state.pillDates && this.state.pillDates.length != 0) {
      if (this.state.colorDatesObj && this.state.colorDatesObj[date.toDateString()]) {
        return (<div className="donePill" style={{ background: this.state.colorDatesObj[date.toDateString()] }}>{dayComponent}</div>)
      }
      if (this.state.missedPillDates.includes(date.toDateString())) {
        return (<div className="hasMissedPill">{dayComponent}</div>)
      }
      if (this.state.pillDates.includes(date.toDateString())) {
        return (<div className="isPillDay">{dayComponent}</div>)
      }
    }
    return dayComponent
  }


  resetCalender = () => {
    var that = this;
    const { t } = this.props;
    OffileDb.newremoveData('calenderDates').then(function (result) {
      that.calculateDays(that.state.firstBleeding)
      swal({
        text: t("New reminder date set successfully"),
        icon: "success",
        button: t("ok"),
      })
    })
  };

  onDateChange = (date) => {
    this.setState({ firstBleeding: date })
  };

  onTimeChange = (time) => {
    this.setState({ reminderTime: time })
  };

  onTypeChange = (type) => {
    this.setState({ reminderType: type })
  };

  changeMode = () => {
    const { t } = this.props;
    var that = this;
    OffileDb.getData('calenderDates').then(function (result) {
      if (!result.status && result.status != 400) {
        if (that.state.reminderType == 1) {
          that.triggerReminder(result.data.pillDates)
        } else if (that.state.reminderType == 2) {
          that.setWhatsappReminder(result.data.pillDates)
        }
      }
    })
    swal({
      text: t("Reminder mode change successfully"),
      icon: "success",
      button: t("ok"),
    })
  }

  setTime = () => {
    const { t } = this.props;
    var that = this;
    OffileDb.getData('calenderDates').then(function (result) {
      if (!result.status && result.status != 400) {
        that.triggerReminder(result.data.pillDates)
        swal({
          text: t("New reminder time set successfully"),
          icon: "success",
          button: t("ok"),
        })
      }
    })
  };

  setWhatsappReminder(pillDates) {
    var param = {
      pillDates: pillDates,
      userNo: "+917530007709"
    };
    Services.getWhatsappReminder(param).then((res) => {
      try{
        console.log(res)
        if (res.status == 200) {
          console.log("success whatsapp");
        }
      }catch(err){
        console.log("err::", err)
      }
    })
  }

  triggerReminder = (pillDates) => {
    if (window.cordova) {
      var t = this.state.reminderTime.split(":");
      var hour = parseInt(t[0]);
      var min = parseInt(t[1]);
      pillDates.forEach(element => {
        window.cordova.plugins.notification.local.hasPermission(function (granted) {
          if (granted == true) {
            window.cordova.plugins.notification.local.schedule({
              title: "Pill reminder",
              text: "Don't forget to eat your pills today!",
              trigger: { at: new Date((new Date(element)).getFullYear(), (new Date(element)).getMonth(), (new Date(element)).getDate(), hour, min) }

            });
          } else {
            window.cordova.plugins.notification.local.requestPermission(function (granted) {
              if (granted == true) {
                window.cordova.plugins.notification.local.schedule({
                  title: "Pill reminder",
                  text: "Don't forget to eat your pills today!",
                  trigger: { at: new Date((new Date(element)).getFullYear(), (new Date(element)).getMonth(), (new Date(element)).getDate(), hour, min) }
                });
              }
            });
          }
        });
      });
    }
  }


  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    var pillDates = this.state.pillDates;
    var selectedDate = this.state.selectedDate;
    var userCalenderRemainderInfo = this.state.userCalenderRemainderInfo;
    var colorDatesObj = this.state.colorDatesObj
    var calenderRemainderQuestionList = userCalenderRemainderInfo.calenderRemainderRegistrationQuestionResponseList[0].calenderRemainderQuestionList;
    return (
      <div>
        { this.state.isLoading ? (<Loader isLoading={this.state.isLoading} />) : (
          <>
          <div className="remindersettingiconholder">
            <Calendarsettings
              onDateChange={(date) => { this.onDateChange(date) }}
              onTimeChange={(time) => { this.onTimeChange(time) }}
              onTypeChange={(type) => { this.onTypeChange(type) }}
              resetCalender={() => { this.resetCalender() }}
              setTime={() => { this.setTime() }}
              changeMode={() => { this.changeMode() }}
            >
            </Calendarsettings>
            </div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around" className="reminderpicker">
                <DatePicker
                  autoOk
                  renderDay={this.renderDayInPicker}
                  variant="static"
                  openTo="date"
                  value={this.state.selectedDate}
                  onChange={this.handleDateChange}
                />
              </Grid>
            </MuiPickersUtilsProvider>
            {
              this.state.showmodal && pillDates.length > 0 && new Date(selectedDate).setHours(0, 0, 0, 0) <= (new Date(this.state.Today).setHours(0, 0, 0, 0)) && pillDates.includes(selectedDate.toDateString()) ?
                (<div className="pillQuestionnaire">
                  {
                    calenderRemainderQuestionList.map((Obj) => {
                      return <Questionnaire onQuestionClick={(color) => { this.onQuestionClick(color, selectedDate) }} question={Obj} />;
                    })
                  }
                </div>) : ('')
            }
            {pillDates.length == 0 &&
              (
                <div className='pillstatusholder'>
                  <div>
                    <Grid container spacing={12} className="gridcontainer">
                      <div className="pillstatus-header d-flex aligin-items-center">
                        {
                          userCalenderRemainderInfo.remainderIcon != '' && (
                            <Grid item xs={2} className="">
                              <div className="">
                                <h3 className="zero color-red d-flex aligin-items-center">
                                  <img className="statusheaderimg" src={userCalenderRemainderInfo.remainderIcon} />
                                </h3>
                              </div>
                            </Grid>
                          )
                        }

                        <Grid item xs={10} className="">
                          <div className="">
                            <h4 className="zero color-red">{userCalenderRemainderInfo.remainderFor}</h4>
                            <h5 className="zero color-red">{selectedDate.toDateString().substr(3)}</h5>
                          </div>
                        </Grid>
                      </div>
                      <Grid item xs={12} className="d-flex aligin-items-center">
                        {
                          userCalenderRemainderInfo.remainderOption ? (
                            <div className={templateID == 1 ? "getknwtitle text-left" : "color-green"}>{t(userCalenderRemainderInfo.remainderOption)}</div>
                          ) : (
                            <div className={templateID == 1 ? "getknwtitle text-left" : "color-green"}>{t('Set your start date?')}</div>
                          )
                        }
                      </Grid>
                      <Grid item xs={12} className="text-left mt-20px" onClick={() => { this.setFirstBleeding(selectedDate) }}>
                        <Button
                          type="submit"
                          variant="contained"
                          style={bgStyles}
                          color="primary"
                          disableElevation
                          className={templateID == 1 ? "login_btn" : "reportsubmitbtn"}
                          ref="submitbtn"
                        >
                          {t('submit')}
                        </Button>
                        {/* <div>
                          <p className="zero yesiconholder">
                            <ThumbUpAltOutlinedIcon></ThumbUpAltOutlinedIcon>
                          </p>
                          <p className="zero">{t('Yes')}</p>
                        </div> */}
                      </Grid>
                    </Grid>
                  </div>
                </div>
              )
            }
          </>
        )
        }
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : state.storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    activeTabObj: storeState.activeTabObj,
    componentbgcolor: storeState.componentbgcolor
  };
};


const transSerives = withTranslation()(MaterialUIPickers);
const ThemeServices = withTheme(transSerives);
const routeServices = withRouter(ThemeServices);
export default connect(mapStateToProps, { setactiveTabObj })(routeServices);
